<template>
    <div>
        <div class="big-card">
            <h2>
                {{
                    action === "add"
                        ? $vuetify.lang.t("$vuetify.addNew")
                        : $vuetify.lang.t("$vuetify.editNews")
                }}
            </h2>
            <v-card-text>
                <v-form ref="form">
                    <v-text-field
                        :placeholder="$vuetify.lang.t('$vuetify.title')"
                        v-model="newNew.title"
                        :rules="titleRules"
                        required
                        outlined
                    ></v-text-field>
                    <text-editor
                        :disable-image-upload="false"
                        v-model="newNew.text"
                    ></text-editor>
                    <v-checkbox
                        v-model="newNew.archiveable"
                        :label="$vuetify.lang.t('$vuetify.archiveable')"
                    ></v-checkbox>
                    <v-checkbox
                        v-model="newNew.public"
                        :label="$vuetify.lang.t('$vuetify.public')"
                    ></v-checkbox>
                </v-form>
                <v-alert
                    v-model="alertError"
                    close-text="CLose"
                    color="error"
                    dismissible
                >
                    {{ alertMsg }}
                </v-alert>
            </v-card-text>
            <v-card-actions>
                <div class="news-card__file-input">
                    <img
                        v-if="newNew.photo_path"
                        class="img-small"
                        :src="$media_url + newNew.photo_path"
                        alt=""
                    />
                    <v-file-input
                        class="file-input"
                        v-model="photoField"
                        accept=".jpg, .png, .jpeg"
                        :placeholder="
                            $vuetify.lang.t('$vuetify.uploadNewsImage')
                        "
                        :prepend-icon="newNew.photo_path ? ' ' : '$photo'"
                    ></v-file-input>
                </div>

                <v-spacer></v-spacer>

                <div class="btn-group">
                    <button
                        class="btn btn-secondary link-not-like"
                        @click="$router.go(-1)"
                    >
                        {{ $vuetify.lang.t("$vuetify.back") }}
                    </button>
                    <button class="btn btn-primary" @click="addNew">
                        {{
                            action === "add"
                                ? $vuetify.lang.t("$vuetify.publish")
                                : $vuetify.lang.t("$vuetify.save")
                        }}!
                    </button>
                </div>
            </v-card-actions>
        </div>
    </div>
</template>
<script>
import TextEditor from "./TextEditor.vue";

export default {
    name: "news-add",

    components: { TextEditor },

    props: {
        id: String,
    },

    data: function () {
        return {
            photoField: null,
            photoDialog: false,
            titleRules: [(v) => !!v || "Необходимо ввести заголовок"],
            newNew: {
                id: 0,
                title: "",
                text: "",
                photo_path: null,
                archiveable: true,
                public: false,
            },
            alertMsg: "",
            action: "add",
            alertError: false,
        };
    },

    mounted() {
        if (this.id) {
            this.action = "edit";
            this.loadData();
        }
    },

    methods: {
        loadData() {
            this.$axios({
                url: this.$hostname + "time-tracking/news/" + this.id,
                method: "GET",
            }).then((response) => {
                this.newNew = response.data.data.data[0];
            });
        },

        addNew() {
            if (this.$refs.form.validate()) {
                const formData = new FormData();
                if (this.photoField) formData.append("image", this.photoField);
                if (this.id) formData.append("id", this.id);

                formData.append("title", this.newNew.title);
                formData.append("text", this.newNew.text);
                formData.append("public", this.newNew.public);
                formData.append("archiveable", this.newNew.archiveable);

                const method = this.action === "add" ? "post" : "put";
                // const url = this.action === 'add'
                //   ? this.$hostname + "time-tracking/news"
                //   : this.$hostname + "time-tracking/news/" + this.id;
                const url = this.$hostname + "time-tracking/news";

                this.$axios({
                    method,
                    url,
                    headers: {
                        Authorization:
                            "Token " +
                            (localStorage.getItem("auth_token") ||
                                sessionStorage.getItem("auth_token")),
                    },
                    data: formData,
                })
                    .then(() => {
                        this.$router.push("/news");
                    })
                    .catch((error) => {
                        this.alertError = true;
                        this.alertMsg =
                            error.response?.data?.message ||
                            "Ошибка при сохранении";
                    });
            } else {
                this.alertError = true;
                this.alertMsg = "Заполните обязательные поля";
            }
        },
    },
};
</script>
